import React from 'react'

class CountDownTimerC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: {},
            seconds: 0,
            changeSeconds: '-',
            cutoffPassed: false
        };
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }
    calculateCutOff = async cutoffTime => {
        let diff;
        const now = new Date().getTime()
        const cutoff = cutoffTime ? new Date(cutoffTime).getTime() : null
        if (cutoff && cutoff > now) {
            diff = cutoff - now
            this.setState({
                changeSeconds: "-",
                cutoffPassed: false,
            });
        } else if (cutoff && cutoff < now) {
            diff = now - cutoff
            this.setState({
                changeSeconds: "+",
                cutoffPassed: true,
            });
        }

        if (diff) {
            let diffInSec = parseInt(diff / 1000)
            this.setState({ seconds: diffInSec })
        }
    }

    secondsToTime(secs) {
        let days = Math.floor(secs / (60 * 60 * 24));

        let divisor_for_hours = secs % (60 * 60 * 24);
        let hours = Math.floor(divisor_for_hours / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "d": days,
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    async componentDidMount() {
        await this.calculateCutOff(this.props.cutoff)
        this.startTimer()
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    startTimer() {
        if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        let seconds
        if (this.state.changeSeconds === '-') {
            seconds = this.state.seconds - 1;
        } else if (this.state.changeSeconds === '+') {
            seconds = this.state.seconds + 1;
        }

        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        if (seconds === 0) {
            this.setState({
                changeSeconds: "+",
            });
        }
    }

    render() {
        let isPassed = this.state.cutoffPassed ? 'ago' : null
        if (this.state.time.d && this.state.time.h && this.state.time.m) {
            return <span style={this.state.cutoffPassed ? { color: '#CA3142' } : {}}>{this.state.time.d} days {this.state.time.h} hours {this.state.time.m} minutes {isPassed}</span>
        } else if (!this.state.time.d && this.state.time.h && this.state.time.m) {
            return <span style={this.state.cutoffPassed ? { color: '#CA3142' } : {}}>{this.state.time.h} hours {this.state.time.m} minutes {isPassed}</span>
        } else if (!this.state.time.d && !this.state.time.h && this.state.time.m) {
            return <span style={this.state.cutoffPassed ? { color: '#CA3142' } : {}}>{this.state.time.m} minutes {isPassed}</span>
        }
        else {
            return '-'
        }
    }
}
export default CountDownTimerC